import { render, staticRenderFns } from "./DeveloperModelDetails.vue?vue&type=template&id=38ad100e&"
import script from "./DeveloperModelDetails.vue?vue&type=script&lang=js&"
export * from "./DeveloperModelDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports